<template>
  <div id="app">
    <Navbar v-if="!isAuthPage" />

    <main class="main-content" :class="{ 'login-main': isAuthPage }">
      <router-view v-slot="{ Component, route }">
        <component :is="Component" :key="route.fullPath" />
      </router-view>
    </main>

    <Footer v-if="!isAuthPage" />

    <!-- Toast Notifications -->
    <ToastNotification />
    
    <!-- Dialog Modals -->
    <DialogModals />

    <!-- Annonce de mise à jour diffusée par un administrateur -->
    <MaintenanceNoticeBanner />

    <!-- Nouvelle version déployée : rechargement proposé (ou automatique au prochain changement de page) -->
    <AppUpdateBanner />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import ToastNotification from './components/ToastNotification.vue'
import DialogModals from './components/DialogModals.vue'
import MaintenanceNoticeBanner from './components/MaintenanceNoticeBanner.vue'
import AppUpdateBanner from './components/AppUpdateBanner.vue'


export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    ToastNotification,
    DialogModals,
    MaintenanceNoticeBanner,
    AppUpdateBanner
  },
  computed: {
    isAuthPage() {
      const authRoutes = ['/login', '/reset-password', '/plaintes-reclamations']
      return authRoutes.some(route => this.$route?.path?.startsWith(route))
    }
  },
  setup() {
    // Currency symbol is loaded in router.js for authenticated users
  },
  mounted() {
    // Initialize Bootstrap components after Vue mounting
    this.$nextTick(() => {
      if (typeof bootstrap !== 'undefined') {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        tooltipTriggerList.map(function (tooltipTriggerEl) {
          return new bootstrap.Tooltip(tooltipTriggerEl)
        })

        const dropdownTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]'))
        dropdownTriggerList.map(function (dropdownTriggerEl) {
          return new bootstrap.Dropdown(dropdownTriggerEl)
        })
      }
    })
  }
}
</script>

<style>
/* Bootstrap Icons via CDN - Add to HTML template if needed */
@import url('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.0/font/bootstrap-icons.css');
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');

:root {
  --font-display: 'Outfit', sans-serif;
  --color-primary: #6366f1;
  --color-primary-dark: #4f46e5;
  --color-dark: #0f172a;
  --color-light: #f8fafc;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8fafc;
  background-image: 
    radial-gradient(at 0% 0%, rgba(99, 102, 241, 0.03) 0px, transparent 50%),
    radial-gradient(at 100% 0%, rgba(244, 63, 94, 0.03) 0px, transparent 50%),
    radial-gradient(at 100% 100%, rgba(99, 102, 241, 0.03) 0px, transparent 50%),
    radial-gradient(at 0% 100%, rgba(244, 63, 94, 0.03) 0px, transparent 50%);
  background-attachment: fixed;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.main-content {
  flex: 1;
  padding-top: 90px;
  padding-bottom: 3rem;
  transition: all 0.3s ease;
}

.main-content.login-main {
  padding-top: 0;
  padding-bottom: 0;
}


/* Global Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
